import { Box, BoxProps, Center } from '@chakra-ui/react'

import InfoTutorialIcon from 'src/assets/icon/InfoTutorialSVG'
import { BrandColor } from 'src/types'

const InlineInfoIcon: React.FC<
  {
    brandColor: BrandColor
    onClick?: () => unknown
  } & BoxProps
> = ({ brandColor, onClick, ...props }) => (
  <Box display="inline-block" onClick={onClick} cursor="pointer" {...props}>
    <Center borderRadius="full" bg={brandColor} boxSize="16px">
      <InfoTutorialIcon height="12px" width="12px" />
    </Center>
  </Box>
)

export default InlineInfoIcon
